
import state from './moduleRoleManagementState'
import mutations from './moduleRoleManagementMutations'
import actions from './moduleRoleManagementActions'
import getters from './moduleRoleManagementGetters'

export default {
  isRegistered: false,
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
}

